import React from "react";
import styles from './ImageInput.styl';

function ImageInput(props) {

	const {x, y, title, accept='.jpg,.jpeg,.png', ...addProps} = props
	return (
		<div>
			<label className={styles.selectLabel} style={{top: y + 'px', left: x + 'px'}}>{title}</label>
			<input
				className={styles.selectImg}
				style={{top: y + 30 + 'px', left: x + 'px'}}
				type="file"
				name="file"
				accept={accept}
				{...addProps}
			/>
		</div>
	)
}

export default ImageInput;



// WEBPACK FOOTER //
// ./src/react/ui/features/ImageInput/ImageInput.jsx